import React, { useState } from 'react';
import { NCZICompositionItem } from '../../../Interfaces/ncziTypes';
import EHRNoItemsFound from '../../EHR/EHRNoItemsFound';
import ElectronicDPNListItem from './ElectronicDPNListItem';

interface Props {
	patientIdentifier: string;
	items: NCZICompositionItem[];
	onCloseDetail: (needReload: boolean) => void;
	history?: boolean;
	disableCreate?: boolean;
}

const ElectronicDPNListItems: React.FC<Props> = props => {
	const {
		items,
		onCloseDetail,
		patientIdentifier,
		history = false,
		disableCreate = false,
	} = props;

	if (!items.length) {
		return (
			<>
				<EHRNoItemsFound />
			</>
		);
	}

	return (
		<>
			{items.map((item, key) => {
				if (!item.entry) {
					return <></>;
				}

				return (
					<ElectronicDPNListItem
						key={key}
						item={item.entry}
						patientIdentifier={patientIdentifier}
						onCloseDetail={onCloseDetail}
						history={history}
						readonly={history && key !== 0}
						disableCreate={disableCreate}
					/>
				);
			})}
		</>
	);
};

export default ElectronicDPNListItems;
